import React, { useEffect, useMemo } from 'react';
import { ModalEntryPointContainer } from '@atlassian/jira-entry-point-modal-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { exportIssuesXFlowModalEntryPoint } from './entrypoint.tsx';
import type { ExportingItem } from './ui/types.tsx';

type Props = {
	exportingItem: ExportingItem;
	onClose: () => void;
	query: string;
};

const AsyncExportIssuesXFlowModal = ({ exportingItem, onClose, query }: Props) => {
	const cloudId = useCloudId();

	const entryPointParams = useMemo(
		() => ({
			cloudId,
			query,
		}),
		[cloudId, query],
	);

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		exportIssuesXFlowModalEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	const handleClose = () => {
		entryPointActions.unload();
		onClose();
	};

	return (
		<ModalEntryPointContainer
			id="async.jira.export-issues-xflow-modal"
			data-testid="business-export-issues-xflow-modal.export-issues-xflow-modal"
			packageName="@atlassian/jira-business-export-issues-xflow-modal"
			teamName="A4T Werewolves"
			entryPointReferenceSubject={entryPointReferenceSubject}
			entryPointActions={entryPointActions}
			errorFallback="unmount"
			runtimeProps={{
				onClose: handleClose,
				exportingItem,
			}}
		/>
	);
};

export default AsyncExportIssuesXFlowModal;
